import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';

import * as packageActions from '../actions';
import { PackageDetailService } from '../../package-detail.service';
import { DealDetailService } from '../../../deal-detail/deal-detail.service';

@Injectable()
export class PackageDetailEffects {
  constructor(
    private actions$: Actions,
    private packageDetailService: PackageDetailService,
    private dealDetailsService:DealDetailService
  ) {}

  getPackageDetailBySlug$ = createEffect(() =>
    this.actions$.pipe(
      ofType(packageActions.getPackageDetailBySlug),
      switchMap((action) =>
        this.packageDetailService.getBySlug(action?.slug).pipe(
          map((response) =>
            packageActions.getPackageDetailBySlugSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(packageActions.getPackageDetailBySlugFailure(error))
          )
        )
      )
    )
  );


getDealDetails$ = createEffect(() =>
  this.actions$.pipe(
    ofType(packageActions.getDealDetails),
    switchMap((action) =>
      this.dealDetailsService.getBySlug(action.slug).pipe( 
        map((response) =>
          packageActions.getDealDetailsSuccess({ data: response }) 
        ),
        catchError((error: any) =>
          of(packageActions.getDealDetailsFailure({ error })) 
        )
      )
    )
  )
);
}
